import { registrationConfig } from "@/helpers/config";
import { reactive, toRefs } from "@vue/composition-api";
import { useLoggedInStatus } from "./loggedInStatus";
import { useMemberDetails } from "./member-details";
import { studentCodes } from "./membership";
import { useWorkplaceSearch } from "./workplace-search";

let progressHelper = null;

export function useProgressHelper() {
  if (progressHelper === null) {
    progressHelper = reactive({
      progressStep: -1,
    });
  }

  function setProgressStep(step) {
    progressHelper.progressStep = step;
  }

  return {
    ...toRefs(progressHelper),
    setProgressStep,
  };
}

export function nextStep(router) {
  const memberDetails = useMemberDetails();
  const workplace = useWorkplaceSearch();
  const { currentRoute } = router;
  const { name: routeName, path, query } = currentRoute;
  const minDate = "0001-01-01T00:00:00";
  const { setProgressStep } = useProgressHelper();
  const { overseasMembershipCodes } = registrationConfig;

  // default routes
  if (
    [
      "ThankYou",
      "Wizard",
      "CreateAccount",
      "CheckVerification",
      "NewMember",
      "Membership",
      "Renewal",
    ].includes(routeName)
  )
    return;

  if (query.returnUrl && path.includes("/register/create-login")) return;

  if (!useLoggedInStatus().isLoggedIn.value) {
    if (memberDetails.userName.value === "") {
      router.push({ name: "Contact Details", query: { currentPage: 0 } });
    } else {
      router.push({ name: "Contact Details", query: { currentPage: 1 } });
    }
    return;
  }

  if (useLoggedInStatus().isLoggedIn.value) {
    // Not yet verified
    if (!memberDetails.isVerified.value) {
      router.push({ name: "VerifyAccount" });
      return;
    } else {
      if (
        !memberDetails.title.value ||
        !memberDetails.firstName.value ||
        !memberDetails.lastName.value ||
        !memberDetails.dateOfBirth.value ||
        memberDetails.dateOfBirth.value === minDate ||
        !memberDetails.street.value ||
        !memberDetails.town.value ||
        !memberDetails.county.value ||
        !memberDetails.postCode.value ||
        !memberDetails.country.value ||
        !memberDetails.mobilePhone.value
      ) {
        setProgressStep(2);
        router.push({ name: "Contact Details" });
        return;
      }

      if (studentCodes.includes(memberDetails.membershipStatusType.value)) {
        // if student
        if (
          !memberDetails.university.value ||
          !memberDetails.course.value ||
          !memberDetails.discipline.value ||
          !memberDetails.yearOfStudy.value ||
          !memberDetails.lengthOfCourse.value ||
          !memberDetails.qualificationOnEntry.value ||
          !memberDetails.expectedQualified.value ||
          memberDetails.expectedQualified.value === minDate
        ) {
          router.push({ name: "Place of Study" });
          return;
        }
      } else {
        if (
          (![...overseasMembershipCodes, "RET"].includes(
            memberDetails.membershipStatusType.value,
          ) &&
            !workplace.chosenWorkplace.name) ||
          (["ORD", "NP1", "NP2"].includes(
            memberDetails.membershipStatusType.value,
          ) &&
            !memberDetails.hcpcNumber.value)
        ) {
          router.push({ name: "Work Details" });
          return;
        }

        if (
          !["RET", "RAS"].includes(memberDetails.membershipStatusType.value) &&
          (!memberDetails.university.value ||
            !memberDetails.course.value ||
            !memberDetails.discipline.value ||
            !memberDetails.lengthOfCourse.value ||
            !memberDetails.qualificationOnEntry.value) &&
          (memberDetails.membershipStatusType.value === "APR"
            ? !memberDetails.yearOfStudy.value ||
              !memberDetails.expectedQualified.value ||
              memberDetails.expectedQualified.value === minDate
            : !memberDetails.dateQualified.value ||
              memberDetails.dateQualified.value === minDate)
        ) {
          router.push({ name: "Place of Study" });
          return;
        }
      }

      if (
        !memberDetails.gender.value ||
        !memberDetails.ethnicity.value ||
        !memberDetails.nationality.value
      ) {
        router.push({ name: "Diversity Details" });
        return;
      }

      router.push({ name: "Review" });
      return;
    }
  }
}
